import { render } from "./ButtonTemplate.vue?vue&type=template&id=5865824e&ts=true"
import script from "./ButtonTemplate.vue?vue&type=script&lang=ts"
export * from "./ButtonTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__